class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    const title = this.querySelector('.collapsible__title');
    const content = this.querySelector('.collapsible__content');

    const updateHeight = () => {
      if (title.getAttribute('active') === 'true') {
        const prevHeight = content.style.height;
        content.style.height = 'auto';
        const newScrollHeight = `${content.scrollHeight}px`;
        content.style.height = prevHeight;

        requestAnimationFrame(() => {
          content.style.height = newScrollHeight;
        });
      }
    };

    if (title && title.getAttribute('active') === 'true') {
      updateHeight();
    } else {
      title?.setAttribute('active', 'false');
    }

    title?.addEventListener('click', function (e) {
      if (title.getAttribute('active') === 'true') {
        title.setAttribute('active', 'false');
        content.setAttribute('active', 'false');
        content.style.height = '0px';
        if (title.classList.contains('read-more-link')) title.innerHTML = title.dataset.readMore;
      } else {
        title.setAttribute('active', 'true');
        content.setAttribute('active', 'true');
        if (title.classList.contains('read-more-link')) title.innerHTML = title.dataset.readLess;
        updateHeight();
      }
    });

    // Quand un <details> FAQ s'ouvre/ferme, recalculer la hauteur du collapsible parent
    this.querySelectorAll('details').forEach(details => {
      details.addEventListener('toggle', () => {
        requestAnimationFrame(updateHeight);
      });
    });

    // Quand un collapsible enfant finit son animation, recalculer aussi
    content.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'height') {
        this.dispatchEvent(new CustomEvent('collapsible-child-changed', { bubbles: true }));
      }
    });
    this.addEventListener('collapsible-child-changed', (e) => {
      if (e.target !== this) updateHeight();
    });

    window.addEventListener('resize', updateHeight);
  }
}

customElements.define('collapsible-element', CollapsibleElement);
